
  <div class="ng2-auto-complete">

    <!-- keyword input -->
    <input *ngIf="showInputTag"
           #autoCompleteInput class="keyword"
           placeholder="{{placeholder}}"
           (focus)="showDropdownList($event)"
           (blur)="hideDropdownList()"
           (keydown)="inputElKeyHandler($event)"
           (input)="reloadListInDelay($event)"
           [(ngModel)]="keyword" />

    <!-- dropdown that user can select -->
    <ul *ngIf="dropdownVisible" [class.empty]="emptyList">
      <li *ngIf="isLoading" class="loading">{{loadingText}}</li>
      <li *ngIf="minCharsEntered && !isLoading && !filteredList.length"
           (mousedown)="selectOne('')"
           class="no-match-found">{{noMatchFoundText || 'No Result Found'}}</li>
      <li *ngIf="blankOptionText && filteredList.length"
          (mousedown)="selectOne('')"
          class="blank-item">{{blankOptionText}}</li>
      <li class="item"
          *ngFor="let item of filteredList; let i=index"
          (mousedown)="selectOne(item)"
          [ngClass]="{selected: i === itemIndex}"
          [innerHtml]="autoComplete.getFormattedListItem(item)">
      </li>
    </ul>

  </div>


// WEBPACK FOOTER //
// ./~/ng2-auto-complete/dist/ng2-auto-complete.component.d.ts.Ng2AutoCompleteComponent.html